const routes = [
    {
        path: '/',
        name: 'emailInput',
        component: () => import(/* webpackChunkName: "emailInput" */ '../../views/MailSignup/EmailInput.vue')
    }
]

export default routes